import DesignDataService, { isWidget } from '@configuratorware/configurator-frontendgui/App/Services/DesignDataService';
import {
  getSelectedDesignProductionMethodIdentifier,
  getSelectedDesignArea, getDefaultDesignAreaIdentifierFromProductionMethod,
} from '@configuratorware/configurator-frontendgui/App/Reducers/DesignArea/Selectors';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import first from 'lodash/first';
import { isDesignerProductPreviewMode, updateColorAmountOnDesignProductionMethodChange } from '@configuratorware/configurator-frontendgui/App/Reducers/Configurator/Selectors';
import setupDesigner from '@configuratorware/configurator-frontendgui/App/Modules/Designer/setupDesigner';

export default class CustomDesignDataService extends DesignDataService {
    getFirstDesignArea = () => first(this.getDesignAreas());

    init() {
      super.init();
      /*
      Services.store.observeStore(
        (state) => state.designArea.filteredDesignAreas,
        async (filteredDesignAreas, prevDesignAreas) => {
          try {
            const initList = await this.initCanvases(filteredDesignAreas, prevDesignAreas);
            // only the newly initialized canvases has to be loaded
            const areasToLoad = initList
              .filter(({ isNew }) => isNew)
              .map(({ designArea }) => designArea);
            // the canvas data is there first with the configuration, but since the canvas instances are
            // associated with the design areas the data can be loaded only when the design areas are available
            // eslint-disable-next-line no-unused-expressions
            !isDesignerProductPreviewMode()
                    && areasToLoad.length
                    && (await this.loadCanvasDataFromState(areasToLoad));

            this.selectInitialDesignView();
            this.designAreaListChangeListener(filteredDesignAreas);
          } catch (e) {
            // eslint-disable-next-line no-console
            console.error('Error occurred in processing design area list change:', e);
          }
        },
      );

      Services.store.observeStore(
        (state) => state.designArea.maxZoom2d,
        (maxZoom2d) => {
          Services.visualization.update2DMaxZoom(maxZoom2d);
        },
      );
      // in calculation widget mode the canvas events should be disabled,
      // the update is done directly after the modifications
      if (isWidget(location.pathname)) {
        this.toggleCanvasDataUpdate(false);
        Services.store.observeStore(
          getSelectedDesignProductionMethodIdentifier,
          (selectedDesignProductionMethod) => {
            updateColorAmountOnDesignProductionMethodChange(selectedDesignProductionMethod);
          },
        );
      }

      setupDesigner(this); */
    }

    selectInitialDesignView() {
      const { state } = Services.store;
      const designAreaIdentifier = getSelectedDesignArea(state).identifier
            || getDefaultDesignAreaIdentifierFromProductionMethod(state);
      const designAreaToShow = first(state.designArea.filteredDesignAreas);

      if (designAreaToShow) super.selectDesignView('schraeg');
    }

    async restoreCanvasDataForCurrentDesignArea(canvasData) {
      if (!canvasData) {
        return;
      }
      const designArea = getSelectedDesignArea(Services.store.state);
      this.setCanvasData(canvasData);
      await this.loadCanvasDataFromState([designArea]);
      this.clearSelectionOnCurrentDesignArea();
    }
}
